import React from "react";
import "./index.scss";

const TechBaseFooter = (props) => {
  return (
    <div className="d-flex flex-column align-items-center">
      <nav className="jombiz-footer-nav-container flex flex-col md:flex-row">
        <a className="jombiz-login-nav md:border-r md:px-4" href="mailto:support@jommall.com">
          Contact Us
        </a>
        <a
          className="jombiz-login-nav md:border-r md:px-4"
          href="https://www.jommall.com/en/term-condition"
          target="_blank"
        >
          Terms and Conditions
        </a>
        <a
          className="jombiz-login-nav md:border-r md:px-4"
          href="https://www.jommall.com/en/privacy-policy"
          target="_blank"
        >
          Privacy Policy
        </a>
        <a
          className="jombiz-login-nav md:px-4"
          href="https://www.jommall.com/en/return-refund"
          target="_blank"
        >
          Return & Refund
        </a>
      </nav>
      <div className="jombiz-copyright text-center techbase-footer">
        Copyright © 2025 JomMall. All rights reserved.
      </div>
    </div>
  );
};

export default TechBaseFooter;
